import { get } from "../../../utils/object-helpers";

$ {
    const text = get(input, "text", "");
    const listingStyles = get(input, "listingStyles", []).join(" ");
    const toolTip = get(input, "tooltip", "");
    const toolTipPointer = get(input, "tooltipPointer", null);
    const styles = get(input, "styles", []).join(" ");
}

<div class=`str-listing-text-span ${toolTip && "str-listing-text-span__tooltip"}`>
    <span class=`${listingStyles} ${styles}`>${text}</span>
    <if(toolTip)>
        <ebay-infotip pointer=toolTipPointer a11y-close-text="Dismiss infotip" aria-label="Important information">
            <@content><p>${toolTip}</p></@content>
        </ebay-infotip>
    </if>
</div>
